import styled from 'styled-components';

export const FlagBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const ChooseCoutryBox = styled.div`
  width: 40px;
  position: relative;
  cursor: pointer;
  display: flex;
  background-color: #ccc;
  z-index: 999999;
`;

export const ChooserBox = styled.div<{ open: boolean }>`
  position: absolute;
  top: 0;
  left: ${props => props.open ? '-260px' : '40px'};
  width: 300px;
  transition: left 100ms linear;
  overflow: hidden;
  background: #fff;
  z-index: 99999;
`;

export const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: 'MontserratMedium';
  padding: 8px;
  background-color: #333;
  font-size: 13px;
  color: #fff;
`;

export const SingleCountry = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 1px 5px;
  background-color: ${props => props.active ? '#ddd' : '#eee'};
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  &:hover {
    background-color: #ddd;
  }
`;

export const CountryName = styled.div<{ active: boolean }>`
  font-family: ${props => props.active ? 'MontserratMedium' : 'Montserrat'};
  padding-left: 5px;
`;

export const ChooserBody = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;